import Icon from "../Icon";
import { GRID_SELECTION_TAG_LIMIT } from "../../modules/search/consts";
import { RenderWhen } from "../index";

type TagsSelectionMessageProps = {
  hasNoLocalSamples: boolean;
  hasMixedSamples: boolean;
  selectedCountTotalOverLimit?: boolean;
};

const ActionsModalSelectionsMessage = ({
  hasNoLocalSamples,
  hasMixedSamples,
  selectedCountTotalOverLimit = false
}: TagsSelectionMessageProps) => {
  return (
    <div className="d-flex align-items-start mb-20">
      <Icon name="info-circle" className="me-5" />
      <div>
        {selectedCountTotalOverLimit && (
          <div className="mb-10">
            This action is limited to {GRID_SELECTION_TAG_LIMIT} local samples.
          </div>
        )}
        {(hasNoLocalSamples || hasMixedSamples) && (
          <div>
            This action is supported for local samples only.{" "}
            <RenderWhen condition={hasMixedSamples}>
              <>It will not apply to samples which are not local.</>
            </RenderWhen>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionsModalSelectionsMessage;
